import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  card: {
    backgroundColor: theme.palette.common.white,
    border: 'solid 1px #dedede',
    boxShadow: '0 2px 6px 0 #dddddd',
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    maxWidth: 'auto',
    padding: theme.spacing(2),
  },

  icon: {
    marginTop: theme.spacing(-0.3),
    position: 'relative',
    width: '18px',
  },

  link: {
    color: '#005aa3',
    cursor: 'pointer',
    fontFamily: 'Source Sans Pro',
    fontSize: 14,
    marginRight: theme.spacing(2.4),
  },

  status: {
    fontFamily: 'Source Sans Pro Semibold',
    marginRight: theme.spacing(0.3),
  },

  title: {
    fontFamily: 'Source Sans Pro Semibold',
    marginRight: theme.spacing(0.6),
  },

  tooltipHotspot: {
    cursor: 'pointer',
  },

  tooltipPopup: {
    maxWidth: '450px',
  },

  totalValue: {
    fontFamily: 'Source Sans Pro Bold',
    fontSize: '18px',
    marginLeft: theme.spacing(0.6),
  },
})
